import React from 'react'

import { Box, Text, WizardStepRenderParams, useOnNext } from '@factorialco/deprecated-design-system'
import { RichTextEditor, RichTextEditorHandle } from '@factorialco/f0-react/dist/experimental'

import TextArea from 'modules/core/components/TextArea'
import useRichTextEditor from 'modules/core/hooks/useRichTextEditor'
import { track } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { WizardData } from 'modules/trainings/components/Shared/WizardComponent/types'

type Props = {
  amplitudeEventNext: string
}
export const TrainingNeedStep = ({
  data,
  onDataChanged,
  amplitudeEventNext,
}: WizardStepRenderParams<WizardData> & Props) => {
  const onTrainingNeedChange = (trainingNeed: string) => {
    onDataChanged({ ...data, trainingNeed: trainingNeed })
  }
  const { editorConfig, canUseRichTextEditor, loading: richTextEditorLoading } = useRichTextEditor()
  const trainingNeedRichTextEditorRef = React.useRef<RichTextEditorHandle>(null)

  useOnNext(() => {
    track(amplitudeEventNext, {
      from: 'my_request',
    })
  })

  return (
    <Box width="s600" gap="s24">
      <Text size="400" weight="medium" color="grey1000">
        {i18n.t('trainings.training_requests.create.training_need_step')}
      </Text>
      {richTextEditorLoading ? (
        <RichTextEditor.Skeleton />
      ) : canUseRichTextEditor ? (
        <RichTextEditor
          ref={trainingNeedRichTextEditorRef}
          {...editorConfig}
          onChange={(value) => onDataChanged({ ...data, trainingNeed: value?.value ?? '' })}
          placeholder={i18n.t('trainings.training_requests.create.training_need.placeholder')}
          initialEditorState={{ content: data.trainingNeed || '' }}
          title={i18n.t('trainings.training_requests.create.training_need.label')}
          height="sm"
        />
      ) : (
        <TextArea
          value={data.trainingNeed}
          label={i18n.t('trainings.training_requests.create.training_need.label')}
          placeholder={i18n.t('trainings.training_requests.create.training_need.placeholder')}
          onChange={onTrainingNeedChange}
          mandatory
        />
      )}
    </Box>
  )
}
